import React, { useEffect, useRef } from 'react';
import propTypes from 'prop-types';

function Dialog({ id, type, children, open, onClose, animation = 'default', direction = 'right' }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') {
        onClose();
      }
    }
    dialogRef.current.addEventListener('keydown', handleKeyDown);

    return () => {
      dialogRef.current.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      id={id}
      ref={dialogRef}
      className={`dealer-dialog dealer-dialog--${type} dealer-dialog--animation-${animation} dealer-dialog--direction-${direction}`}
      data-open={open ? 'true' : 'false'}
      inert={!open ? true : false}
    >
      {children}
    </div>
  );
}

Dialog.propTypes = {
  id: propTypes.string,
  type: propTypes.oneOf(['map', 'single-dealer']),
  animation: propTypes.oneOf(['none', 'default']),
  direction: propTypes.oneOf(['left', 'right']),
  children: propTypes.node,
  open: propTypes.bool,
  onClose: propTypes.func,
};

export default Dialog;
